/**
 * Rounds a number to the nearest n.
 * Always rounds up when the number is less than n.
 *
 * @param amount - number to round
 * @param nearest - number to round to
 * @returns the rounded value
 */
export function roundToNearest(amount: number, nearest: number) {
	if (amount <= nearest) {
		return nearest;
	}
	return Math.round(amount / nearest) * nearest;
}
